import {
  NewsEventListDataTypes,
  NewsParamsTypes,
  NewsVideoDataTypes,
  NewsDetailsTypes,
  ManagementReportParamsTypes,
  DownloadGovernanceReportParamsTypes,
  DownloadReportResponseTypes,
  ManagementReportDataTypes,
  DownloadFinancialReportParamsTypes,
  DownloadFinancialReportResponseTypes,
  FinancialReportsListTypes,
} from './types';

import { FinancialReportsParamsTypes } from 'services/analyticsCenter/economicInformation/types';
import axiosInstance from 'services/common/instance';

export const getNewsEventListService = async (
  params: NewsParamsTypes,
): Promise<PaginationData<NewsEventListDataTypes[]>> => {
  const res = await axiosInstance.get('news', { params });
  return res.data;
};

export const getNewsVideoListService = async (
  params: NewsParamsTypes,
): Promise<PaginationData<NewsVideoDataTypes[]>> => {
  const res = await axiosInstance.get('news-videos', { params });
  return res.data;
};

export const getNewsDetailsService = async (
  slug: string,
): Promise<NewsDetailsTypes> => {
  const response = await axiosInstance.get(`news/${slug}`);
  return response.data.data;
};

export const getManagementReportListService = async (
  params?: ManagementReportParamsTypes,
): Promise<PaginationData<ManagementReportDataTypes[]>> => {
  const res = await axiosInstance.get('governance-reports', { params });
  return res.data;
};

// Tạo link download báo cáo tình hình quản trị công ty
export const postDownloadManagementReportService = async (
  params: DownloadGovernanceReportParamsTypes,
): Promise<DownloadReportResponseTypes> => {
  const body = {
    financial_report_id: params.governance_report_id,
    grecaptcha_token: params.grecaptcha_token,
  };
  const res = await axiosInstance.post(
    'governance-reports/create-download',
    body,
  );
  return res.data.data;
};

// Tạo link download báo cáo tình hình quản trị công ty ngay
export const postDownloadManagementReportNowService = async (
  params: DownloadGovernanceReportParamsTypes,
): Promise<DownloadReportResponseTypes> => {
  const body = {
    governance_report_id: params.governance_report_id,
    grecaptcha_token: params.grecaptcha_token,
  };
  const res = await axiosInstance.post(
    'governance-reports/create-download-now',
    body,
  );
  return res.data.data;
};
const getFinancialReportsListService = async (
  params?: FinancialReportsParamsTypes,
): Promise<PaginationData<FinancialReportsListTypes[]>> => {
  const res = await axiosInstance.get('financial-reports', { params });
  return res.data;
};

// Tạo link download báo cáo tài chính
export const postDownloadFinancialReportService = async (
  params: DownloadFinancialReportParamsTypes,
): Promise<DownloadFinancialReportResponseTypes> => {
  const body = {
    financial_report_id: params.financial_report_id,
    grecaptcha_token: params.grecaptcha_token,
  };
  const res = await axiosInstance.post('financial-reports/create-download', body);
  return res.data.data;
};

// Tạo link download báo cáo tài chính ngay
export const postDownloadFinancialReportNowService = async (
  params: DownloadFinancialReportParamsTypes,
) => {
  const body = {
    financial_report_id: params.financial_report_id,
    grecaptcha_token: params.grecaptcha_token,
  };
  await axiosInstance.post('financial-reports/create-download-now', body);
};
export default getFinancialReportsListService;
